/* eslint-disable
  no-console,
  no-unused-vars
*/
import VueUniqIds from 'vue-uniq-ids'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import '@/assets/index.scss'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import LoadScript from 'vue-plugin-load-script'
Vue.config.productionTip = false;

const requireComponent = require.context(
// The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
    // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
});

window.$ = require('jquery');
window.JQuery = require('jquery');
window.jQuery = require('jquery');
const $ = window.$;
const jQuery = window.jQuery;
const JQuery = window.JQuery;

new Vue({
  render: h => h(App)
}).$mount('#app');

Vue.use(Vuex);
Vue.use(VueHead);
Vue.use(VueRouter);
Vue.use(LoadScript);
